import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DataAvailabilityAlert } from '../../Shared/DataAvailabilityAlert';
import {
  selectEpisodeMetadata,
  selectEpisodeMetadataStatus,
  LOADING,
} from '../../../store/selectors';
import { ReduxState, EpisodeMetadata } from '../../../types';

type Props = {
  status?: 'LOADING' | 'ERROR' | 'UNAUTHORIZED';
  episodeData?: EpisodeMetadata;
};

class EpisodePageWithDataAlert extends PureComponent<Props> {
  get hasData() {
    return this.props.episodeData && this.props.episodeData.streams > 0;
  }

  render() {
    /* istanbul ignore next */
    if (this.props.status === LOADING) {
      return null;
    }

    if (this.hasData) {
      return this.props.children;
    }

    return <DataAvailabilityAlert />;
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    episodeData: selectEpisodeMetadata(state),
    status: selectEpisodeMetadataStatus(state),
  };
}

export const ConnectedEpisodePageWithDataAlert = connect(mapStateToProps)(EpisodePageWithDataAlert);
